/* eslint-disable no-restricted-globals */
import $ from 'jquery';
import { invokeAuthenticationPopup } from './invoke-authentication-popup';
import { fakeLogger } from './utils';
import { AuthPopupCallbacks, ILogger, TokenResponse } from '../types';

export function fetchTokenExchange(
  url: string,
  retry: number = 0,
  logger: ILogger = fakeLogger,
): Promise<TokenResponse> {
  return new Promise((resolve, reject) => {
    const fetchToken = (retriesLeft: number) => {
      $.ajax({
        url,
        type: 'get',
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true,
        },
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        success(result: TokenResponse) {
          if (result.ResultType === 1 || result.ResultType === 3) {
            reject(result);
          } else {
            resolve(result);
          }
        },
        error(e: JQuery.jqXHR<any>) {
          if (retriesLeft > 0) {
            logger?.trace(`Retrying to fetch token, retries left ${retriesLeft} of ${retry}`);
            fetchToken(retriesLeft - 1);
          } else {
            logger?.error(`All ${retry} retries exhausted, failed to fetch token`);
            reject(e ?? {});
          }
        },
        converters: {
          // eslint-disable-next-line func-names
          'text json': function (result: string) {
            return result === '' ? result : JSON.parse(result);
          },
        },
      });
    };

    fetchToken(retry);
  });
}

export const fetchTokenWithAuthenticationPopup = (
  fetchTokenUrl: string,
  loginPopupUrl: string,
  popupRedirectUrl: string,
  bypassAuthPopup: boolean,
  scenario: string,
  onAuthPopupSuccess: AuthPopupCallbacks['onAuthPopupSuccess'] = () => {},
  onAuthPopupFailure: AuthPopupCallbacks['onAuthPopupFailure'] = () => {},
  logger: ILogger = fakeLogger,
  retry: number = 0,
) => new Promise<TokenResponse>((resolve, reject) => {
  fetchTokenExchange(fetchTokenUrl, retry)
    .then(({ token }) => {
      logger.trace(`[${scenario}] /cc/tokenExchange returned token: length=${token?.length}`);
      if (token == null && !bypassAuthPopup) {
        logger.trace(
          `[${scenario}] MSA sign in started, loginPopupUrl: ${loginPopupUrl}`,
        );
        invokeAuthenticationPopup(
          loginPopupUrl,
          () => {
            onAuthPopupSuccess();
            logger.trace(`[${scenario}] MSA sign in suceeded`);
            resolve(fetchTokenExchange(fetchTokenUrl, retry));
          },
          (error: any) => {
            logger.error(
              `[${scenario}] MSA sign in failed. ${JSON.stringify(error)})}`,
            );
            onAuthPopupFailure();
            resolve({ token: null });
          },
          popupRedirectUrl,
        );
      } else {
        resolve({ token });
      }
    })
    .catch((e) => {
      logger.error(
        `[${scenario}] Call token exchange API failed: ${e.message}`,
      );
      reject(e);
    });
});
